import { api1 } from "../utils/axiosInstance";
import { datasets } from "../constants/constants";
import { API_ENDPOINTS } from "./apiEndpoints";

export const fetchUserProfile = (userId) => {
  return api1.get(`${API_ENDPOINTS.GET_SINGLE_PROFILE}/${userId}`);
};

// Fetch user profile and dispatch to Redux
export const fetchAndStoreUserProfile = (userId) => async (dispatch) => {
  try {
    const { data } = await fetchUserProfile(userId);
    dispatch({ type: 'user/setUser', payload: data });
    return data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
};

export const fetchCurrentJobDescription = async (occupationId, token) => {
  try {
    if (!occupationId || !token) return "";

    const { data } = await api1.post("/api/lightcast/get-occupation-benchmark-data", {
      jobId: occupationId,
      datasets,
      token,
    });

    return data?.data?.description || "";
  } catch (error) {
    console.error("Error fetching job description:", error);
    return "";
  }
};

export const submitUserProfile = (formData) => {
  return api1.post(API_ENDPOINTS.CREATE_PROFILE, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateUserProfilePreferences = (userId, preferences) => {
  return api1.patch(`${API_ENDPOINTS.UPDATE_PROFILE}/${userId}`, preferences, {
    headers: { "Content-Type": "application/json" },
  });
};

export const markWelcomeSeen = () => {
  return api1.put(API_ENDPOINTS.MARK_WELCOME_SEEN, {}, {
    meta: { showToast: false }, // Don't show success toast for this silent operation
  });
};

export const updateHasAIJobImpact = (userId, hasAIJobImpact) => {
  return api1.patch(`${API_ENDPOINTS.UPDATE_PROFILE}/${userId}`, { hasAIJobImpact }, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateUserProfile = (userId, formData) => {
  return api1.patch(`${API_ENDPOINTS.UPDATE_PROFILE}/${userId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
